import React from 'react'
import StyledText from '../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';

interface SecTitleIconDesc {
    icon?: React.ReactNode;
    title: string;
    desc: string;
    fontWeight?: number;
    fontSize?: string;
    fontColor?: string;
    descfontWeight?: number;
    descfontSize?: string;
    descfontColor?: string;
}

const SecTitleWithIconDesc: React.FC<SecTitleIconDesc> = ({
    icon,
    title,
    desc,
    fontColor,
    fontSize,
    fontWeight,
    descfontWeight,
    descfontSize,
    descfontColor
}) => {
    const { theme } = useTheme();
    return (
        <div className='d-flex align-items-center'>
            {icon &&
                <span
                    className='icon d-flex align-items-center justify-content-center me-3'
                    style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '10px',
                        backgroundColor: theme.name === 'light' ? `#0050FF0D` : '#white',
                    }}
                >
                    {icon}
                </span>
            }
            <div className='ml-2'>
                <StyledText
                    textColor={fontColor ? fontColor : theme.CorporateTheme.colors.primary}
                    fontSize={fontSize ? fontSize : '16px'}
                    fontWeight={fontWeight ? fontWeight : 600}
                    style={{ marginBottom: '5px' }}
                >
                    {title}
                </StyledText>
                <StyledText
                    textColor={descfontColor ? descfontColor : theme.CorporateTheme.colors.textSecondary}
                    fontSize={descfontSize ? descfontSize : '14px'}
                    fontWeight={descfontWeight ? descfontWeight : 500}
                >
                    {desc}
                </StyledText>
            </div>
        </div>
    )
}

export default SecTitleWithIconDesc